export default __webpack_public_path__ + "static/media/italian_icon.22e2858f.svg";